import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { api } from '../lib/api'
import type { Answer, Question } from '../gen/types'

export interface QAPair {
  question: Question
  answer: Answer
}

export function useAskSamiksh(reviewId: string) {
  const [history, setHistory] = useState<QAPair[]>([])

  const ask = useMutation({
    mutationFn: (params: {
      text: string
      revisionId?: string
      scopeHint?: string
      anchorPath?: string
      anchorStartLine?: number
      anchorEndLine?: number
    }) => api.askQuestion({ reviewId, ...params }),
    onSuccess: (data) =>
      setHistory((prev) => [...prev, { question: data.question, answer: data.answer }]),
  })

  return { history, ask }
}
